import React from "react";

import {
  ActionButton,
  Card,
  CardActions,
  Description,
  Meta,
  ProgressBar,
  ProgressFill,
  RequiredBadge,
  StatusBadge,
  Thumbnail,
  Title,
  TypeLabel,
} from "./styled";

export default function LearningPathStepItemCard({
  item,
  loading,
  onComplete,
  onOpen,
}) {
  const percent = Math.max(0, Math.min(Number(item?.completionPercent || item?.progress?.completionPercent || 0), 100));
  const isDocument = item?.itemType === "document" || item?.type === "documents";
  const statusLabel = item?.completed
    ? "Completed"
    : item?.status === "in_progress"
      ? "In progress"
      : "Not started";

  return (
    <Card completed={item?.completed}>
      {item?.imageUrl || item?.cover ? <Thumbnail image={item.imageUrl || item.cover} /> : null}
      <Meta>
        <TypeLabel>{isDocument ? "Document" : "Course"}</TypeLabel>
        {item?.required === false ? null : <RequiredBadge>Required</RequiredBadge>}
        <StatusBadge completed={item?.completed}>{statusLabel}</StatusBadge>
      </Meta>
      <Title>{item?.title}</Title>
      {item?.description ? <Description>{item.description}</Description> : null}
      <ProgressBar>
        <ProgressFill style={{ width: `${percent}%` }} />
      </ProgressBar>
      <CardActions>
        <ActionButton type="button" onClick={() => onOpen(item)} disabled={loading}>
          {isDocument ? "Open document" : "Open course"}
        </ActionButton>
        {!isDocument || item?.completed ? null : (
          <ActionButton type="button" secondary onClick={() => onComplete(item)} disabled={loading}>
            Mark as completed
          </ActionButton>
        )}
      </CardActions>
    </Card>
  );
}
